module.exports = __webpack_public_path__ + "92bfc52bfee4467cd64264b63d64d862.jpeg";